import { onLogout } from "@/vue-apollo";

export default {
  methods: {
    $logout(redirect = false) {
      this.$invalidatePermissionCache();
      onLogout(this.$apollo);
      if (redirect)
        this.$router.push({ name: "login", query: { redir: this.$route.path } });
      else
        this.$router.push({ name: "login" });
    },
  },
};
